/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 17:18:59
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-04 15:16:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/tools.ts
 * @LastEditTime: 2021-03-24 16:34:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/tools.ts
 */

import _ from 'lodash';
import { errCodesMap } from 'src/error/code';
import {
  defaultCollapse,
  EnumCollapseId,
  generateDefaultFeaturedProducts,
  generateDefaultSearchBar,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/common';
import { randomNumber, reduxUpdatedStatusControl } from 'src/tools/helper';

// const validateHotTagsTitle = (seoSetting) => {
//   const err = [];

//   return err;
// };
const validateHotTags = (settings, isPrimary?) => {
  const { items, title } = settings || {};

  const err = [];
  if (!title) {
    err.push(errCodesMap[100000]);
  }
  if ((items || []).length === 0) {
    err.push(errCodesMap[100001]);
  }

  return {
    hasError: err.length > 0,
    generalError: err,
    specificError: {},
  };
};

export { validateHotTags };

export const convertDataFromServerToRedux = (data, isPrimary?) => {
  const {
    enabled,
    hasError,
    hotTags,
    searchBar = {},
    featuredProducts = {},
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    miniProgramShare,
    miniProgramPageInfo,
    translationEnabled,
  } = data;

  const _isNew = modifiedDate === createdDate;

  const { title, items = [] } = hotTags || {};
  const { collapseOpen, collapseErrorMsgDisplay } = defaultCollapse(!_isNew);
  if (hasError && enabled) {
    //const _tErr = validateHotTagsTitle(title);
    const { hasError } = validateHotTags(hotTags, isPrimary);
    if (hasError) {
      collapseErrorMsgDisplay[EnumCollapseId.hotTags].hasError = true;
      collapseOpen[EnumCollapseId.hotTags] = true;
    }
  }
  const _searchBar = searchBar;
  // if (!_searchBar.placeholder) {
  //   _searchBar.placeholder = '搜索';
  // }
  const _r = {
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    enabled,
    hotTagsTitle: title,
    hotTags: (items || []).map((i) => {
      return { ...i, draggableId: randomNumber() };
    }),
    searchBar: _searchBar || generateDefaultSearchBar(),
    featuredProducts: featuredProducts || generateDefaultFeaturedProducts(),
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    collapseOpen,
    collapseErrorMsgDisplay,
    modifiedDate,
    createdDate,
    translationEnabled,
    ...reduxUpdatedStatusControl,
  };
  //console.log('_r', _r);
  return _r;
};

export const convertDataFromReduxToServer = (state) => {
  const _state = _.cloneDeep(state || {});
  const {
    enabled,
    hotTagsTitle,
    hotTags,
    searchBar,
    featuredProducts,
    contentUuid,
    uuid,
    miniProgramShare,
    miniProgramPageInfo,
  } = _state;
  if (enabled) {
    return {
      contentUuid,
      uuid,
      enabled,

      hotTags: {
        title: hotTagsTitle,
        items: hotTags,
      },
      searchBar,
      featuredProducts,
      miniProgramShare,
      miniProgramPageInfo,
    };
  } else {
    return {
      contentUuid,
      uuid,
      enabled,
    };
  }
};
